(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slideshow-youtube-slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const playTrigger = event.target.closest('media-play-button.youtube-slide__play, [data-slide-type="youtube"] video-media');
    if (!playTrigger) return;

    const slideshow = playTrigger.closest('slideshow-carousel');
    slideshow?.player?.pause();
  });
  } catch(e) { console.error(e); }
})();

})();
